import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const TrustedCompanies = () => {
  const clients = [
    "logos/tek.png",
    "logos/am.png",
    "logos/reginald-men.png",
    "logos/doyen-logo.png",
    "logos/quiklee.png",
    "logos/aaroohee-healthcare.png",
    
  ];

  return (
    <section className="" style={{ padding: "56px 0px 22px 0px", backgroundColor: "#dce0e5" }} >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-3 mb-2 mb-md-0">
            <h5 className="pe-6">70+ Companies trust us</h5>
          </div>

          <div className="col-md-9">
            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              slidesPerView={2}
              spaceBetween={50}
              breakpoints={{
                576: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
                1200: { slidesPerView: 5 },
              }}
              loop={true}
              className="client-slider"
            >
              {clients.map((logo, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={logo}
                    alt={`client-${index}`}
                    className="grayscale img-fluid"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedCompanies;
